"use client";

import clsx from "clsx";
import type { ComponentProps } from "react";

import { ComingSoon } from "@shared/ui/coming-soon";
import { Icon } from "@shared/ui/icon";
import { Link } from "@shared/ui/link";
import { StatusBadge } from "@shared/ui/status-badge";
import { TrailNumber } from "@shared/ui/trail-number";
import { formatLength } from "@shared/utils/format-trail-info";
import { getStatusLabel } from "@shared/utils/get-status-label";

import type { TrailPageType } from "@/_pages/single-trail/model/types";

import s from "./trail-list-item.module.scss";

export type TrailListItemProps = ComponentProps<"div"> & {
  className?: string;
  cellClassName?: string;
  trail: TrailPageType;
};

export const TrailListItem = (props: TrailListItemProps) => {
  const { className, cellClassName, trail } = props;

  const numberAndTitle = trail.title;

  const startElevation = trail.start
    ? formatLength(trail.start.toString())
    : null;
  const endElevation = trail.end ? formatLength(trail.end.toString()) : null;

  return (
    <div className={clsx(s.root, className)}>
      <div className={s.inner}>
        <div className={clsx(s.cell, cellClassName)}>
          <div className={s.name}>
            {trail.trailNumber && (
              <TrailNumber
                className={s.number}
                variant={trail.difficulty || "medium"}
                size="24"
              >
                {trail.trailNumber}
              </TrailNumber>
            )}
            {numberAndTitle}
          </div>
        </div>
        <div className={clsx(s.cell, cellClassName)}>
          {trail?.comingSoon ? (
            <ComingSoon text={trail?.comingSoon} />
          ) : (
            <StatusBadge variant={trail.trailStatus}>
              {getStatusLabel(trail.trailStatus)}
            </StatusBadge>
          )}
        </div>
        <div className={clsx(s.cell, cellClassName)} data-label="Протяженность">
          {formatLength(trail.length)}
        </div>
        <div
          className={clsx(s.cell, cellClassName)}
          data-label="Начальная высота"
        >
          {startElevation || "-"}
        </div>
        <div
          className={clsx(s.cell, cellClassName)}
          data-label="Конечная высота"
        >
          {endElevation || "-"}
          <Icon name="arrow-right" className={s.icon} size={24} />
        </div>
      </div>
      {!trail?.comingSoon && (
        <Link
          variant="block"
          href={`/trails/${trail.uid}`}
          className={s.link}
          aria-label={numberAndTitle ?? undefined}
        >
          &nbsp;
        </Link>
      )}
    </div>
  );
};

TrailListItem.displayName = "TrailListItem";
